import { View } from "@src/components";
import { useUnistyles } from "react-native-unistyles";
import { Button } from "@src/components/Button";
import { Icon } from "@src/components/Icon";

interface ClipActionButtonsProps {
  onBookmark: () => void;
  onDownload: () => void;
}

export function ClipActionButtons({ onBookmark, onDownload }: ClipActionButtonsProps) {
  const { theme } = useUnistyles();

  return (
    <View flexDirection="row" gap="md" mb="4xl">
      <View style={{ flex: 1 }}>
        <Button
          onPress={onBookmark}
          size="md"
          label="Bookmark"
          variantColor="navy"
          textStyle="md/semibold"
          iconLeft={
            <Icon
              name="star"
              size={theme.spacing["7xl"]}
              color={theme.colors.interactive.buttons.default_foreground as string}
            />
          }
        />
      </View>

      <View style={{ flex: 1 }}>
        <Button
          onPress={onBookmark}
          size="md"
          label="Download"
          variantColor="navy"
          textStyle="md/semibold"
          iconLeft={
            <Icon
              name="download"
              size={theme.spacing["5xl"]}
              color={theme.colors.interactive.buttons.default_foreground as string}
            />
          }
        />
      </View>
    </View>
  );
}
